export type TranslateTimeElapsed = (
  value: number,
  unit: "Second" | "Minute" | "Hour" | "Day" | "Week" | "Month" | "Year"
) => string;

export const getFormattedTimeElapsed = (value: number | string, translateTimeElapsed: TranslateTimeElapsed): string => {
  const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000);
  const statusTimestampInSeconds = new Date(value).getTime() / 1000;
  const seconds = Math.floor(currentTimeInSeconds - statusTimestampInSeconds);

  if (seconds < 60) return translateTimeElapsed(seconds, "Second");

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return translateTimeElapsed(minutes, "Minute");

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return translateTimeElapsed(hours, "Hour");

  const days = Math.floor(hours / 24);

  if (days < 7) return translateTimeElapsed(days, "Day");

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return translateTimeElapsed(weeks, "Week");

  const months = Math.floor(days / 30.44 /* Average number of days in a month */);
  if (months < 12) return translateTimeElapsed(months, "Month");

  const years = Math.floor(months / 12);
  return translateTimeElapsed(years, "Year");
};
